// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconCrossCircle = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M12 10.586l2.121-2.122 1.415 1.415L13.414 12l2.121 2.121-1.414 1.415L12 13.414l-2.121 2.122-1.414-1.415 2.12-2.12-2.12-2.122 1.413-1.415z" />,
    <path fillRule="evenodd" d="M12 21a9 9 0 100-18 9 9 0 000 18m0-2a7 7 0 100-14 7 7 0 000 14" />
  );
export default SvgIconCrossCircle;
